import { Trans } from '@lingui/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function CreateApiKeyButton(props) {
    const { appearance, icon = true } = props;
    return (<Button type="button" appearance={appearance} onClick={() => null}>
      {icon && <Falcon icon="plus"/>}
      <Trans comment="Create api key button label">Create key</Trans>
    </Button>);
}
